// Responsive Grid
import { Container, Row, Col } from "react-grid-system";
import { TrackedLink } from "@components/analytics/TrackedLink";
import Breadcrumbs from "@components/Breadcrumbs";
import { ImgSrc } from "@config/image";
import theme from "@config/theme";

const LandingToolsSdks = () => (
  <Container className="landingGridContainer">
    <Row>
      <Col md={12} lg={8}>
        <Breadcrumbs
          links={[
            { name: "Docs", url: "/docs" },
            { name: "Tools & SDKs", url: "/tools-and-sdks" },
          ]}
        />
        <h1>Developer Tools & SDKs</h1>
        <p>
          Accelerate your development with command-line tools, firmware
          libraries, and a collection of host MCU samples.
        </p>
      </Col>
    </Row>

    <Row>
      <Col>
        <div className="flex-container flex-container-first">
          <div>
            <h2>Notecard CLI</h2>
            <p>
              Configure, debug, and interact with your Notecard using our
              cross-platform command-line interface.
            </p>
            <TrackedLink
              href="/tools-and-sdks/notecard-cli"
              className="btn btnSecondary"
            >
              Set up the CLI
            </TrackedLink>
          </div>
          <div>
            <img
              src={ImgSrc("/images/tools-and-sdks/notecard_cli.svg")}
              alt="An example of using the Notecard CLI"
            />
          </div>
        </div>
      </Col>
    </Row>

    <Row>
      <Col>
        <div className="flex-container">
          <div>
            <h2>Firmware Libraries</h2>
            <p>
              Start building your Notecard-powered app using our libraries for
              Arduino, Python, C/C++, Go, or TinyGo.
            </p>
            <TrackedLink
              href="/tools-and-sdks/firmware-libraries/libraries-overview"
              className="btn btnSecondary"
            >
              View the Libraries
            </TrackedLink>
          </div>
          <div>
            <img
              src={ImgSrc("/images/tools-and-sdks/firmware-libraries.png")}
              alt="Logos of the languages the framework libraries support"
            />
          </div>
        </div>
      </Col>
    </Row>

    <Row>
      <Col>
        <div className="flex-container">
          <div>
            <h2>Notehub JS Library</h2>
            <p>
              Quickly start interacting with the Notehub API in any
              JavaScript-based application with our Notehub JS library.
            </p>
            <TrackedLink
              href="/tools-and-sdks/notehub-js-library/"
              className="btn btnSecondary"
            >
              View the Library
            </TrackedLink>
          </div>
          <div>
            <img
              src={ImgSrc("/images/tools-and-sdks/notehub-js.webp")}
              alt="Blues Notehub JS npm library logo"
            />
          </div>
        </div>
      </Col>
    </Row>

    <Row>
      <Col>
        <div className="flex-container">
          <div>
            <h2>Samples</h2>
            <p>
              Explore samples for working with the Notecard on host MCUs, as
              well as complete project implementations you can reference or
              clone.
            </p>
            <TrackedLink
              href="/tools-and-sdks/samples/samples-overview"
              className="btn btnSecondary"
            >
              View the Samples
            </TrackedLink>
          </div>
          <div>
            <img
              src={ImgSrc("/images/tools-and-sdks/host-mcu-samples.png")}
              alt="Example source code from the host MCU samples"
            />
          </div>
        </div>
      </Col>
    </Row>

    <style jsx>{`
      .flex-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 2rem 0;
        border-top: 1px solid ${theme.colors.gray4};
      }
      .flex-container-first {
        margin-top: 4rem;
      }

      .flex-container img {
        margin-left: 2rem;
        max-width: 550px;
      }
      :global(.landingGridContainer) .flex-container h2 {
        margin-top: 0;
      }
      @media screen and (max-width: ${theme.breakpoints.lg}px) {
        .flex-container {
          flex-direction: column;
          align-items: flex-start;
        }
        .flex-container img {
          margin-top: 2rem;
          margin-left: 0;
          max-width: 100%;
        }
      }
    `}</style>
  </Container>
);

export default LandingToolsSdks;
